// const TRUSTED_ROW_SELECTOR = '.trusted-sec__row-marquee';
// const TRUSTED_ROW_INIT_CLASS = 'is-init-trusted-row-marquee';

// function initTrustedRows(gsap) {
//   let currentScroll = window.pageYOffset;
//   let isScrollingDown = true;
//   let scrollTimeout;

//   document.querySelectorAll(TRUSTED_ROW_SELECTOR).forEach((row) => {
//     if (row.classList.contains(TRUSTED_ROW_INIT_CLASS)) {
//       return;
//     }

//     row.classList.add(TRUSTED_ROW_INIT_CLASS);

//     const track = row.querySelector('.trusted-sec__row-track');
//     const content = track?.querySelector('.trusted-sec__row-content');

//     if (!track || !content) {
//       return;
//     }

//     const clone = content.cloneNode(true);
//     track.appendChild(clone);
//     track.appendChild(clone);
//     track.appendChild(clone);

//     const contentWidth = content.offsetWidth;

//     gsap.set(track, { x: -contentWidth });

//     const tween = gsap.to(track, {
//       x: `-=${contentWidth}`,
//       duration: 135,
//       ease: 'linear',
//       repeat: -1,
//       modifiers: {
//         x: gsap.utils.unitize((x) => parseFloat(x) % contentWidth),
//       },
//     });

//     tween.totalProgress(0.5);

//     window.addEventListener('scroll', () => {
//       const newScroll = window.pageYOffset;
//       isScrollingDown = newScroll > currentScroll;
//       currentScroll = newScroll;

//       gsap.to(tween, {
//         timeScale: isScrollingDown ? 2 : -2,
//         overwrite: true,
//         duration: 0.2,
//       });

//       clearTimeout(scrollTimeout);
//       scrollTimeout = setTimeout(() => {
//         gsap.to(tween, {
//           timeScale: isScrollingDown ? 1 : -1,
//           duration: 0.5,
//           ease: 'power2.out',
//         });
//       }, 300);
//     });
//   });
// }

// if (document.querySelector(TRUSTED_ROW_SELECTOR)) {
//   import('gsap')
//     .then((gsapModule) => {
//       const gsap = gsapModule.gsap || gsapModule.default || gsapModule;
//       initTrustedRows(gsap);
//     })
//     .catch(() => {});
// }
